module.exports = __webpack_public_path__ + "img/5.c310b046.jpeg";